<div class="academy"><div class="container">
<div class="row">
  <div class="col-md-6">
    <div class="academy-box">
      <h1>Academy</h1>
    <p>We are a group of experienced retail professionals whose mission is to <br> help retailers and vendors grow their retail business by helping <br> themdevelop their People and   We do this by mixing our real <br> timeexperience with professional education to make our <br> solutionsProcesses.</p>
    </div>
    
  </div>
  <div class="col-md-6">
    <div class="academy-img-box">
      <img src="../../../assets/academy/Group 22099.png" alt="">
    </div>
  </div>
</div>

</div></div>

<div class="learn"><div class="container">
  <h1>Making online learning more effective, <br> simple, and engaging</h1>
<div class="row l1">
  <div class="col-md-6">
    <div class="learn-img-box">
      <img src="../../../assets/academy/Group 10490.png" alt="">
    </div>
  </div>
  <div class="col-md-6">
    <div class="learn-box">
      <h3>Sales Enabling</h3>
      <p>These courses develop the set of, and technical competencies <br> required to deliver high quality of retail products and services. <br> Learners receive the depth of knowledge that is relevant to their <br> role in the retail management hierarchy. The main objective of <br> these courses is to enable sales by providing the customers <br> without affecting customers satisfaction or perception.</p>
    <button>Show More</button>
    </div>
  </div>
</div>
<div class="row l2">
  
  <div class="col-md-6">
    <div class="learn-box">
      <h3>Sales Enabling</h3>
      <p>These courses develop the set of, and technical competencies <br> required to deliver high quality of retail products and services. <br> Learners receive the depth of knowledge that is relevant to their <br> role in the retail management hierarchy. The main objective of <br> these courses is to enable sales by providing the customers <br> without affecting customers satisfaction or perception.</p>
    <button>Show More</button>
    </div>
  </div>
  <div class="col-md-6">
    <div class="learn-img-box">
      <img src="../../../assets/academy/Group 18874.png" alt="">
    </div>
  </div>
</div>
<div class="row l3">
  <div class="col-md-6">
    <div class="learn-img-box">
      <img src="../../../assets/academy/Group 22375.png" alt="">
    </div>
  </div>
  <div class="col-md-6">
    <div class="learn-box">
      <h3>Sales Enabling</h3>
      <p>These courses develop the set of, and technical competencies <br> required to deliver high quality of retail products and services. <br> Learners receive the depth of knowledge that is relevant to their <br> role in the retail management hierarchy. The main objective of <br> these courses is to enable sales by providing the customers <br> without affecting customers satisfaction or perception.</p>
    <button>Show More</button>
    </div>
  </div>
  
</div>

</div></div>




<div class="container">
  <div class="bites">
    <div class="row">
    <div class="col-md-7">
      <h1>If your business needs <br> solutions</h1>
    <button>Get in Touch</button>

    </div>
  <div class="col-md-5">
    <div class="image">
<img src="../../../assets/sol/Group 12594.png" alt="">
    </div>
  </div>
  </div>
  </div>
</div>